import React, { SyntheticEvent } from 'react';
import CssBaseline from '@material-ui/core/CssBaseline';
import ErrorIcon from '@material-ui/icons/Error';
import CloseIcon from '@material-ui/icons/Close';
import IconButton from '@material-ui/core/IconButton';
import { useApolloClient, useQuery } from '@apollo/react-hooks';
import gql from 'graphql-tag';
import { Snackbar, SnackbarCloseReason, SnackbarContent } from '@material-ui/core';
import { ConfirmProvider } from 'material-ui-confirm';
import './index.css';
import { useStyles } from './css';

const LOCAL_ERROR_QUERY = gql`
    query ErrorQuery {
        showError @client
        errorMessage @client
    }
`;

export const App: React.FC = ({ children }: { children: React.ReactChildren }) => {
    const classes = useStyles();
    const { data: gqlState } = useQuery(LOCAL_ERROR_QUERY);

    const client = useApolloClient();

    const handleErrorClose = (event: SyntheticEvent, reason?: SnackbarCloseReason) => {
        if (reason === 'clickaway') {
            return;
        }

        client.writeData({ data: { showError: false } });
    };

    return (
        <React.Fragment>
            <ConfirmProvider>
                <CssBaseline />
                {gqlState && gqlState.showError && (
                    <Snackbar
                        anchorOrigin={{
                            vertical: 'bottom',
                            horizontal: 'center',
                        }}
                        open={gqlState.showError}
                        onClose={(e, reason) => {
                            handleErrorClose(e, reason);
                        }}
                        className={classes.errorSnackbar}
                    >
                        <SnackbarContent
                            className={classes.errorContent}
                            message={
                                <span id="error-snackbar" className={classes.errorMessage}>
                                    <ErrorIcon className={classes.errorIcon} />
                                    {gqlState.errorMessage}
                                </span>
                            }
                            action={[
                                <IconButton
                                    key="close"
                                    aria-label="close"
                                    color="inherit"
                                    onClick={e => {
                                        handleErrorClose(e);
                                    }}
                                >
                                    <CloseIcon className={classes.errorCloseIcon} />
                                </IconButton>,
                            ]}
                        />
                    </Snackbar>
                )}

                {children}
            </ConfirmProvider>
        </React.Fragment>
    );
};
